import { createContext, ReactNode, useContext } from 'react';
import { BaseRouter, LinkProps } from './BaseRouter';

const RouterContext = createContext<BaseRouter | null>(null);

export const RouterProvider: React.FC<{
  router: BaseRouter;
  children: ReactNode;
}> = ({ router, children }) => {
  return (
    <RouterContext.Provider value={router}>{children}</RouterContext.Provider>
  );
};

export const useRouter = (): BaseRouter => {
  const router = useContext(RouterContext);

  if (!router) {
    throw new Error('useRouter must be used within a RouterProvider');
  }

  return router;
};

export const useReplace = () => {
  const router = useRouter();

  return router.replace;
};

export const useNavigate = () => {
  const router = useRouter();

  return router.navigate;
};

export const useSearchParams = () => {
  const router = useRouter();

  return router.searchParams;
};

export const useLocation = () => {
  const router = useRouter();

  return router.pathname;
};

export const useLink = () => {
  const router = useRouter();

  const CustomLink = ({
    to,
    children,
    className,
    rel,
    ...props
  }: LinkProps) => {
    return (
      <router.Link to={to} className={className} rel={rel} {...props}>
        {children}
      </router.Link>
    );
  };

  return CustomLink;
};
